import React from 'react';
import { withFeatureSafe } from 'Common/ErrorBoundaries';
import PropTypes from 'prop-types';

const CustomRadio = ({ onChange, options, name, label, direction, disabled, checked }) => {
    return (
        <div className={`flex flex-col gap-2  ${disabled && 'opacity-60 pointer-events-none'}`}>
            {label && <div className='text-secondary  mb-2 font-medium text-sm'>{label}</div>}
            <div className={`flex gap-4 ${direction === "Vertical" && "flex-col"}`}>
                {options.map((option) => (
                    <label key={option.value} className='inline-flex items-center cursor-pointer'>
                        <input
                            type="radio"
                            value={option.value}
                            checked={checked === option.value}
                            name={name}
                            disabled={disabled}
                            onChange={onChange}
                            className="accent-primary w-5 h-5 cursor-pointer"
                        />
                        <span className="ml-1.5">{option.label}</span>
                    </label>
                ))}
            </div>
        </div>
    );
};

export default withFeatureSafe(CustomRadio);
CustomRadio.propTypes = {
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    direction: PropTypes.oneOf(['Vertical', '']),
    disabled: PropTypes.bool,
    checked: PropTypes.string.isRequired,
};

CustomRadio.defaultProps = {
    label: '',
    direction: '',
    disabled: false,
};